import { redirect } from "react-router"
import { useUserInfoStore, useEthereumStore } from "../../state"
import { useSubscriptionStore } from "../../state/stores/subscriptionStore"
import { isReviewerSession } from "../../utils/reviewer"
import { runConnectWalletGate } from "../../utils/reviewer/walletGateFlow.ts"

export const loader = async () => {
  const result = await runConnectWalletGate({
    isReviewer: isReviewerSession,
    getUserInfo: () => useUserInfoStore.getState().getOrFetch(),
    getWalletState: () => useEthereumStore.getState().getOrFetch(),
    disconnectWallet: () => useEthereumStore.getState().disconnectWallet(),
    loadSubscription: () => useSubscriptionStore.getState().loadSubscription(),
    pathname: "",
  })

  if (result.type === "redirect") return redirect(result.to)
  return null
}
